import type { App } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes";
import { createRouterGuards } from "./router-guards";

const router = createRouter({
  history: createWebHistory("/ai-agent/"),
  routes,
  strict: true,
  scrollBehavior: () => ({ left: 0, top: 0 }),
});

export async function setupRouter(app: App) {
  await createRouterGuards(router);

  app.use(router);
}

export default router;
